import {IHttpService} from "angular";
import {AnalyticsType} from "../models/AnalyticsType";

type BeaconFn = (url: string) => void;

export class AnalyticsService {

    public static readonly id = "analyticsService";
    private readonly beaconFn: BeaconFn;

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {
        this.beaconFn = AnalyticsService.beaconSupported() ? this.submitBeacon.bind(this) : this.submitXhr.bind(this);
    }

    private static beaconSupported(): boolean {
        return ("navigator" in window) && ("sendBeacon" in navigator);
    }

    public submit(type: AnalyticsType) {
        const url = `/tradefloor/api/user-interaction/${type}`;

        this.beaconFn(url);
    }

    private submitBeacon(url: string) {
        navigator.sendBeacon(url, null);
    }

    private submitXhr(url: string) {
        setTimeout(() => {
            this.$http.post(url, null);
        });
    }
}
